import client from "services/client";

const getUserDetailsAPI = async (agentId) => {
  const response = await client.get(`/users/${agentId}`);
  return response;
};

const getRolesListAPI = async () => {
  const response = await client.get("authorization/roles?page=1&limit=100");
  return response;
};

export { getUserDetailsAPI, getRolesListAPI };
